import router from "./router"
import store from "./store"
import { Message } from "element-ui"
import NProgress from "nprogress" // progress bar
import "nprogress/nprogress.css" // progress bar style
import { getToken } from "@/utils/auth" // get token from cookie
import { microAppRouter, microAppSetGlobalData } from "@/micro/micro-app-utils"
NProgress.configure({ showSpinner: false }) // NProgress Configuration

// 判断是否修改初始密码
const checkNeedRestPsw = function (next, to, isLogin) {
  if (store.getters.isFirstLogin) {
    next({ name: "resetPsw", redirect: true })
    setTimeout(() => {
      store.dispatch("tagsView/delAllViews")
      document.querySelector(".el-menu").style.display = "none"
      document.querySelector(".sidebar-container").style.display = "none"
      document.querySelector(".hamburger-container").style.display = "none"
    }, 500)
  } else {
    if (isLogin) {
      next({ path: "/", replace: true })
    } else {
      next({ ...to, replace: true })
    }
  }
}

const whiteList = ["/login", "/404"] // no redirect whitelist

// 判断url的微应用是否匹配，比如出现错误：/voyager#/count/drivePageV2，驾驶舱不会出现在wct中
const checkSameHref = function (to) {
  const f_herf = to.fullPath.split("#")[0]?.split("/")[1]
  const s_herf = to.fullPath.split("#")[1]?.split("/")[1]
  // mdm中，这个比较特殊，做s_herf非authorityCenter判断
  if (s_herf !== "authorityCenter") {
    if (f_herf && s_herf && f_herf !== s_herf) {
      location.href = location.href.replace(f_herf, s_herf)
      return false
    }
  }
  return true
}
router.beforeEach(async (to, from, next) => {
  const sanmeCheck = checkSameHref(to)
  if (!sanmeCheck) {
    return
  }
  // start progress bar
  NProgress.start()
  // set page title
  // document.title = getPageTitle(to.meta.title)
  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === "/login") {
      checkNeedRestPsw(next, to, true)
      NProgress.done()
    } else {
      // 判断是否有用户名，如果有直接走，如果没有调接口
      const hasGetUserInfo = store.getters.name
      // 是否修改初始密码
      const isFirstLogin = store.getters.isFirstLogin
      if (hasGetUserInfo) {
        if (isFirstLogin && to.name !== "resetPsw") {
          next({ name: "resetPsw", redirect: true })
          NProgress.done()
        } else {
          next()
        }
      } else {
        try {
          // 获取用户信息
          await store.dispatch("user/getInfo")
          await store.dispatch("user/getIsFirstLogin")
          await store.dispatch("user/getMenu")
          // 获取用户收藏菜单
          await store.dispatch("user/getFavorite")
          checkNeedRestPsw(next, to, false)
        } catch (error) {
          // 清除token，并且去首页重新登录
          store.dispatch("user/clearGlobal")
          Message.error(error || "出问题啦！")
          // next(`/login?redirect=${to.path}`)
          next(`/login`)
          NProgress.done()
        }
      }
    }
  } else {
    /* 没有token */
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      // next(`/login?redirect=${to.path}`)
      next(`/login`)
      NProgress.done()
    }
  }
})

router.afterEach(async (to, from) => {
  // 全局通知子应用登陆token()
  microAppSetGlobalData({ type: "token", data: getToken() })
  // 通知子应用跳转操作
  microAppRouter(to)
  if (to.hash === "#/dashboard?dontJump=true") {
    location.href = location.origin
  }
  // 结束进度条
  NProgress.done()
  if (process.env.NODE_ENV == "production") {
    const checkVersion = await store.dispatch("settings/checkVersion")
    if (!checkVersion) {
      // 获取的版本号不等时
      // 1、强制刷新
      // Message.warning({ message: "检测到新版本，刷新后立即使用", duration: 5000 })
      // Message.warning({ message: "正在自动升级新版本，请稍后...", duration: 3000 })
      // setTimeout(() => {
      //   location.reload() // 版本不同 刷新 获取最新版本
      // }, 3000)
      // 2、需要用户主动刷新，需要考虑只提醒一次，而不是每次切换路由都提示
      // MessageBox.alert('检测到新版本，刷新后立即使用', '发现新版本', {
      //  confirmButtonText: '立即刷新',
      //  showClose: false,
      //  callback: action => {
      //    window.location.reload() // 版本不同 刷新 获取最新版本
      //  }
      // })
    }
  }
})
